module.exports = __webpack_public_path__ + "65017d976d3e9b8f3ce8dff3c91637e0.svg";